var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "join-us" }, [
    _c(
      "div",
      { staticClass: "join-content padding-main mobile-padding" },
      [
        _c(
          "el-row",
          [
            _c("el-col", { attrs: { xs: 24, sm: 24, md: 8 } }, [
              _c("div", { staticClass: "join-title-en" }, [_vm._v("Join us")]),
              _c("div", { staticClass: "join-title" }, [
                _vm._v(_vm._s(_vm.$t("joinUs.joinUs"))),
              ]),
              _c("div", { staticClass: "join-tip" }, [
                _vm._v(_vm._s(_vm.$t("common.yyAddress"))),
              ]),
              _c(
                "div",
                {
                  staticClass: "join-tip",
                  staticStyle: { "margin-bottom": "9.33vw" },
                },
                [_vm._v(_vm._s(_vm.$t("common.yyHrEmail")))]
              ),
            ]),
            _c(
              "el-col",
              {
                staticClass: "join-image",
                staticStyle: { "text-align": "right" },
                attrs: { xs: 24, sm: 24, md: 16 },
              },
              [
                _c(
                  "div",
                  { staticClass: "image-flex" },
                  [
                    _c("el-image", {
                      attrs: { src: "/svg/join_us.svg", fit: "cover" },
                    }),
                  ],
                  1
                ),
              ]
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }